module.exports = __webpack_public_path__ + "img/28.3.TP.ff04829f.png";